// Comun a toda la aplicaion del cliente, busca el token y lo actualiza
import axios from 'axios'
import { TOKEN_KEY } from '../constantes/localStorageKeys'

const searchLocalToken = () => {
  const token = localStorage.getItem(TOKEN_KEY)
  if (token) {
    return {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    }
  }
  return {}
}

// Por defecto, producción: el build de producción no lleva variable de entorno
// y se comporta exactamente igual que antes.
//
// Para desarrollo, crear ClientApp/.env.development.local (está en .gitignore)
// con la URL del backend local, p. ej.:
//     REACT_APP_API_BASE_URL=http://localhost:5001
//
// Otros entornos conocidos:
//     http://dev2.einatec.com:8998/
export const API = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://palex.einatec.com/',
  headers: searchLocalToken(),
})

export const updateToken = () => {
  API.defaults.headers = {
    ...API.defaults.headers,
    ...searchLocalToken(),
  }
}
